import React from 'react'

import { TypographyV2 } from '../../../../Seatbelt2/Foundations/Typography'
import { TooltipWithButton } from '../../../../Tooltip'
import type { AnnualRunningCostProps } from '../ProductCard'
import styles from '../ProductCard.module.scss'

export const AnnualRunningCost = ({
  priceLabel,
  ranking,
  tooltip,
}: AnnualRunningCostProps) => (
  <div className={styles.runningCost} data-testid="annual-running-cost">
    <TypographyV2
      tag="span"
      textStyle="sb-text-interface-body-small-regular"
      className={styles.flexCentre}
    >
      {priceLabel}
      {tooltip && <TooltipWithButton {...tooltip} className={styles.tooltip} />}
    </TypographyV2>
    {ranking && <div className={styles.flexCentre}>{ranking}</div>}
  </div>
)
